import { PayloadAction, createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { StatusEnum } from "../../../commons/enums/status-enum";
import { manageUserService } from "../../../commons";
import { User } from "../../../commons/models/user";

export interface IUserInfoState {
  userInfo: User;
  userInfoStatus: StatusEnum;
}

const initialState: IUserInfoState = {
  userInfo: new User(),
  userInfoStatus: StatusEnum.Idle,
};

export const fetchUser = createAsyncThunk(
  "users/fetchUser",
  async (userId: number, thunkAPI) => {
    try {
      const match = await manageUserService.find(userId);
      return match;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  }
);

const manageUserSlice = createSlice({
  name: "User",
  initialState: initialState,
  reducers: {
    cleanUpUserInfo(state) {
      state.userInfo = new User();
      state.userInfoStatus = StatusEnum.Idle;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(fetchUser.pending, (state) => {
        state.userInfoStatus = StatusEnum.Loading;
      })
      .addCase(fetchUser.fulfilled, (state, action: PayloadAction<User>) => {
        state.userInfoStatus = StatusEnum.Succeeded;
        state.userInfo = action.payload;
      })
      .addCase(fetchUser.rejected, (state) => {
        state.userInfoStatus = StatusEnum.Failed;
      });
  },
});

export const { cleanUpUserInfo } = manageUserSlice.actions;
export default manageUserSlice.reducer;
